import { Commit, Dispatch } from 'vuex';
import StoreUtil from '@store/StoreUtil';
import { isMobile } from '@core/utils/userAgent/UAUtils';
import { showHelp, hideHelp, openChat } from '@modules/help';

export const SET_IS_HELP_VISIBLE = 'SET_IS_HELP_VISIBLE';

export interface IHelpState {
    isHelpVisible: boolean;
}

function defaultState(): IHelpState {
    return {
        isHelpVisible: false,
    };
}

export default {
    namespaced: true,

    state: defaultState(),

    mutations: {
        [SET_IS_HELP_VISIBLE]: StoreUtil.createSimpleMutator('isHelpVisible'),
    },

    actions: {
        showHelp({ commit }: { commit: Commit }) {
            if (isMobile()) {
                showHelp();
            } else {
                openChat();
            }
            commit(SET_IS_HELP_VISIBLE, true);
        },
        hideHelp({ commit }: { commit: Commit }) {
            commit(SET_IS_HELP_VISIBLE, false);
            hideHelp();
        },
        reset({ dispatch }: { dispatch: Dispatch }) {
            dispatch('hideHelp');
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/help/helpIndex.ts